<template>
  <b-table
    striped
    hover
    fixed
    Outlined
    show-empty
    :empty-text="'No data available'"
    :items="mails"
    :fields="fields"
    :table-class="'list-table text-center'"
    :thead-class="'list-table__head'"
    :tbody-class="'list-table__body'"
  >
    <template #cell(Detail)="mail">
      <div>
        <b-button pill class="mw-0" variant="outline-secondary"
          :to="{name: 'MailDetail', params: { notificationId: mail.item.id }}"
        >
          Detail
        </b-button>
      </div>
    </template>
  </b-table>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { Moment } from 'moment'
import { Mail, mailSendStatueType, MailSendStatuses } from '@/store/mails/types'
import { RootState } from '@/store/types'

@Component
export default class MailTable extends Vue {
  private fields = [
    {
      key: 'id',
      label: 'ID',
    },
    {
      key: 'sendAt',
      label: 'Send date',
      formatter: (date: Moment): string => date.format('YYYY/MM/DD'),
    },
    {
      key: 'subject',
      label: 'Subject',
    },
    {
      key: 'status',
      label: 'Status',
      formatter: (type: mailSendStatueType): string => MailSendStatuses[type],
    },
    {
      key: 'Detail',
      label: 'Detail',
    },
  ]

  private get mails(): Mail[] {
    return (this.$store.state as RootState).mails.mails
  }
}
</script>

<style>
.mail-list .list-table .list-table__head {
  font-size: .8rem;
}

.mail-list .list-table .list-table__body td {
  font-size: .8rem;
}
</style>

<style scoped>
.mw-0 {
  min-width: 0;
  font-size: .8rem;
}

.detail-button {
  display: block;
  text-decoration: none;
  color: #000;
  padding: 10px;
  border: 2px solid #AAAFB6;
  border-radius: 20px;
  cursor: pointer;
};

.detail-button:hover {
  background: #000;
};
</style>
